var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-help-icon',{attrs:{"icon":"help","color":"secondary","right":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v(" "+_vm._s(_vm.$t('login.connectionProtocols'))+" ")]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('login.base')))]),_c('li',[_vm._v(_vm._s(_vm.$t('login.LDAP')))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }